import { render, staticRenderFns } from "./RouteSwitcherDropdown.vue?vue&type=template&id=38519def&scoped=true"
import script from "./RouteSwitcherDropdown.vue?vue&type=script&lang=js"
export * from "./RouteSwitcherDropdown.vue?vue&type=script&lang=js"
import style0 from "./RouteSwitcherDropdown.vue?vue&type=style&index=0&id=38519def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38519def",
  null
  
)

export default component.exports